import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getExpirationDate } from "../../welders/lookup/utils";
import { Renewal, RenewalWelder } from "@/api/williams/renewals";
import { useFormContext } from "react-hook-form";
import { useWelderExpirations } from "../hooks";

export function WelderCard({ welder }: { welder: RenewalWelder }) {
  const form = useFormContext<Renewal>();
  const data = form.watch();
  const expirations = useWelderExpirations(welder.welderId, data);

  function handleChanged(update: boolean, reinstatement: boolean) {
    const updatedWelders = data.welders.map((x) =>
      x.welderId === welder.welderId ? { ...x, update, reinstatement } : x
    );

    form.setValue("welders", updatedWelders, {
      shouldDirty: true,
    });
  }

  function handleRemoveWelder() {
    const updatedWelders = data.welders.filter((x) => x.welderId !== welder.welderId);
    form.setValue("welders", updatedWelders, {
      shouldDirty: true,
    });
  }

  return (
    <table className="table table-sm">
      <thead className="table-light">
        <tr>
          <th colSpan={2}>
            <div className="d-flex justify-content-between">
              {welder.name}
              <button
                type="button"
                className="btn btn-link text-black p-0 lh-sm mt-auto"
                title="Remove Welder"
                onClick={handleRemoveWelder}
              >
                <FontAwesomeIcon role="button" icon={faXmark} border={true} />
              </button>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>CFR 192</td>
          <td className="text-end">{getExpirationDate(expirations.data?.cfR192)}</td>
        </tr>
        <tr>
          <td>CFR 195</td>
          <td className="text-end">{getExpirationDate(expirations.data?.cfR195)}</td>
        </tr>
        <tr>
          <td>Basic</td>
          <td className="text-end">{getExpirationDate(expirations.data?.basic)}</td>
        </tr>
        <tr>
          <td>Basic + NDE</td>
          <td className="text-end">{getExpirationDate(expirations.data?.basicNde)}</td>
        </tr>
        {/*<tr>
          <td>Renewal</td>
          <td className="text-end">
            <input
              type="radio"
              name={`card_${welder.welderId}`}
              className="form-check-input"
              checked={welder.update}
              onChange={(e) => handleChanged(e.target.checked, !e.target.checked)}
            />
          </td>
        </tr>
        <tr>
          <td>Reinstatement</td>
          <td className="text-end">
            <input
              type="radio"
              name={`card_${welder.welderId}`}
              className="form-check-input"
              checked={welder.reinstatement}
              onChange={(e) => handleChanged(!e.target.checked, e.target.checked)}
            />
          </td>
        </tr> */}
      </tbody>
    </table>
  );
}
